import { ChainName, NATIVE_TOKEN_ADDRESS, WRAPPED_GAS_TOKENS } from '@src/configs/chainInfo'
import { CHAIN_IDS } from '@src/configs/chainInfo'

/**
 * Maps Solana USDC address to its corresponding EVM address
 * @param tokenAddress The original token address
 * @param isQuote Optional flag to handle null address differently for quotes
 * @param chainIdOrName Optional chain ID or name to get the correct wrapped token address
 * @returns The mapped token address or the original if no mapping exists
 */
export const mapTokenAddress = (tokenAddress: string, isQuote = false, chainIdOrName: ChainName | number): string => {
    const chainId = typeof chainIdOrName === 'string' ? CHAIN_IDS[chainIdOrName] : chainIdOrName

    // Handle native token addresses in quotes
    if (isQuote && tokenAddress === NATIVE_TOKEN_ADDRESS[chainId]) {
        if (chainIdOrName) {
            // Convert chain name to ID if a string is provided
            if (chainId && WRAPPED_GAS_TOKENS[chainId]) {
                return WRAPPED_GAS_TOKENS[chainId].address
            }
        }
    }

    return tokenAddress || ''
}
